export const state = () => ({
  allCategoryDrawerIsOpen: false
})

export const mutations = {
  SET_ALL_CATEGORY_DRAWER_IS_OPEN (state, value) {
    state.allCategoryDrawerIsOpen = value
  }
}
